import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'public/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductEvaluationTaskService {
  refreshDetails = new BehaviorSubject<boolean>(false);
  refreshProducts = new BehaviorSubject<boolean>(false);
  closeDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {
  }

  getAll(params: any): any {
    return this.http.get(`${environment.apiUrl}/ProductEvaluationTask/ListProductEvaluationTasks`, { params });
  }

  createTask(data: any): any {
    return this.http.post(`${environment.apiUrl}/ProductEvaluationTask/CreateTask`, data);
  }

  getEvaluationForms(params: any): any {
    return this.http.get(`${environment.apiUrl}/ProductEvaluationTask/GetEvaluationForms`, { params });
  }

  getRelatedTracks(hubCode): any {
    return this.http.get(`${environment.apiUrl}/ProductEvaluationTask/GetRelatedTracks?hubCode=${hubCode}`);
  }

  getRelatedGroups(params: any): any {
    return this.http.get(`${environment.apiUrl}/ProductEvaluationTask/GetRelatedGroups`, { params });
  }

  getRelatedAmbassadros(params: any): any {
    return this.http.get(`${environment.apiUrl}/ProductEvaluationTask/GetRelatedAmbassadros`, { params });
  }

  getListTasksByAdmin(params: any): any {
    return this.http.get(`${environment.apiUrl}/ProductEvaluationTask/ListTasksByAdmin`, { params });
  }

  getTaskLogs(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/ProductEvaluationTask/GetTaskLogs?taskId=${taskId}`);
  }

  removeTask(id: number) {
    return this.http.delete(`${environment.apiUrl}/ProductEvaluationTask/RemoveTask?id=${id}`);
  }

  getListTasksByAmbassador(params: any): any {
    return this.http.get(`${environment.apiUrl}/ProductEvaluationTask/ListTasksByAmbassador`, { params });
  }

  getTaskDetails(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/ProductEvaluationTask/GetTaskDetails?taskId=${taskId}`);
  }

  getAvailableActions(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/ProductEvaluationTask/GetAvailableActions?taskId=${taskId}`);
  }

  getAllTaskComments(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/ProductEvaluationTask/GetAllTaskComments?taskId=${taskId}`);
  }

  addTaskComment(data: any): any {
    return this.http.post(`${environment.apiUrl}/ProductEvaluationTask/AddTaskComment`, data);
  }

  updateTaskComment(data: any): any {
    return this.http.put(`${environment.apiUrl}/ProductEvaluationTask/UpdateTaskComment`, data);
  }

  deleteTaskComment(commentId: any): any {
    return this.http.delete(`${environment.apiUrl}/ProductEvaluationTask/DeleteTaskComment?commentId=${commentId}`);
  }

  changeTaskStatus(data: any): any {
    return this.http.post(`${environment.apiUrl}/ProductEvaluationTask/ChangeTaskStatus`, data);
  }

  setAmbassadorData(data: any): any {
    return this.http.post(`${environment.apiUrl}/ProductEvaluationTask/SetAmbassadorData`, data);
  }

  getProductToCheckForTaskDetails(taskId: number): any {
    return this.http.get(`${environment.apiUrl}/ProductEvaluationTask/GetProductToCheckForTaskDetails?taskId=${taskId}`);
  }
  getCriteriasToEvaluateProduct(params): any {
    return this.http.get(`${environment.apiUrl}/ProductEvaluationTask/GetCriteriasToEvaluateProduct`, { params });
  }
  getProductEvaluationSurveyResult(params): any {
    return this.http.get(`${environment.apiUrl}/ProductEvaluationTask/GetProductEvaluationSurveyResult`, { params });
  }

  saveTaskAnswers(data: any): any {
    return this.http.post(`${environment.apiUrl}/ProductEvaluationTask/SaveProductEvaluationSurveyAnswers`, data);
  }

  getRelevantSurvey(params): any {
    return this.http.get(`${environment.apiUrl}/ProductEvaluationTask/GetRelevantSurvey`, { params });
  }
}
